<div class="landing-page">
    <!-- <div class="introduce_shadow"><img src="./../assets/img/shadows/shadow_introduce_red_orange.svg" alt=""></div> -->
    <div class="about_me_shadow"><img src="./../assets/img/shadows/shadow_about_me_red.svg" alt=""></div>
    <div class="skills_shadow"><img src="./../assets/img/shadows/shadow_skills_projects_orange.svg" alt=""></div>

    <app-introduce id="app-introduce"></app-introduce>
    <app-about-me id="app-about-me"></app-about-me>
    <app-skills id="app-skills"></app-skills>
    <app-projects id="app-projects"></app-projects>
    <app-contact-form id="app-contact-form"></app-contact-form>
</div>